import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-chevron-up",
  templateUrl: "./med-icon-chevron-up.component.html",
})
export class MedIconChevronUpComponent extends SvgMixinComponent {}
